import { RungeKutta } from "./runge-kutta";
import { Vector3 } from "three";
/**
 * Helper methods for RungeKutta functions.
 */
var RKHelper = /** @class */ (function () {
    function RKHelper() {
    }
    /**
     * Get extrapolated tracks using RungeKutta.
     * @param tracksCollectionsEvent Event containing tracks collections.
     */
    RKHelper.getTracksWithRungeKutta = function (tracksCollectionsEvent) {
        var tracksCollections = Object.assign({}, tracksCollectionsEvent);
        var Tracks = {};
        for (var _i = 0, _a = Object.keys(tracksCollections); _i < _a.length; _i++) {
            var tracksCollection = _a[_i];
            for (var _b = 0, _c = tracksCollections[tracksCollection]; _b < _c.length; _b++) {
                var track = _c[_b];
                track.pos = RKHelper.extrapolateTrackPositions(track);
            }
        }
        return Tracks;
    };
    /**
     * Extrapolate tracks using RungeKutta propagator.
     * @param track Track which is to be extrapolated.
     * @returns An array of track positions.
     */
    RKHelper.extrapolateTrackPositions = function (track) {
        var dparams = track.dparams;
        // ATLAS uses mm, MeV
        var d0 = dparams[0], z0 = dparams[1], phi = dparams[2], theta = dparams[3], qop = dparams[4];
        var p;
        if (qop !== 0) {
            p = Math.abs(1 / qop);
        }
        else {
            p = 0;
        }
        var q = Math.round(p * qop);
        // ATLAS definition of momentum, so probably so move this calc there.
        var globalMomentum = new Vector3(p * Math.cos(phi) * Math.sin(theta), p * Math.sin(phi) * Math.sin(theta), p * Math.cos(theta));
        // Cannot use setFromSphericalCoordinates since ATLAS and threejs use
        // different phi & theta definitions (though both are right-handed)
        var startPos = new Vector3(-d0 * Math.sin(phi), d0 * Math.cos(phi), z0);
        // Wipe existing positions
        var positions = [];
        positions.push([startPos.x, startPos.y, startPos.z]);
        var startDir = globalMomentum.clone();
        startDir.normalize();
        var traj = RungeKutta.propagate(startPos, startDir, p, q, 10, 2500);
        var extrapolatedPos = traj.map(function (val) { return [val.pos.x, val.pos.y, val.pos.z]; });
        return positions.concat(extrapolatedPos);
    };
    return RKHelper;
}());
export { RKHelper };
//# sourceMappingURL=rk-helper.js.map